import { render } from "./TreeSelectionProductsModal.vue?vue&type=template&id=33d67c12&scoped=true&ts=true"
import script from "./TreeSelectionProductsModal.vue?vue&type=script&lang=ts"
export * from "./TreeSelectionProductsModal.vue?vue&type=script&lang=ts"

import "./TreeSelectionProductsModal.vue?vue&type=style&index=0&id=33d67c12&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d67c12"]])

export default __exports__